import React from 'react';
import { Table, Badge, Button, Spinner } from 'react-bootstrap';
import { FaPause, FaPlay, FaUserPlus, FaTrash } from 'react-icons/fa';
import moment from 'moment';

// Linha fictícia "GESTOR" — paridade Delphi UContaSalario.pas linhas 636-644
const LINHA_GESTOR = {
  codigo_usuario: 0,
  nome: 'GESTOR',
  nivel: 0,
  tipo: 'PJ',
  status: 'A',
  suplente_codigo_usuario: null,
  suplente_nome: null,
  suplente_ate: null,
  _fixed: true,
};

const GridHierarquia = ({ tipo, items, onToggleStatus, onAdicionarSuplente, onExcluir, loading }) => {
  const linhas =
    tipo === 'PJ' ? [LINHA_GESTOR].concat(items || []) : items || [];

  if (loading) {
    return (
      <div className="text-center py-3">
        <Spinner animation="border" size="sm" /> Carregando...
      </div>
    );
  }

  if (!linhas.length) {
    return <p className="text-muted text-center py-3">Nenhum usuário cadastrado na hierarquia.</p>;
  }

  return (
    <Table striped bordered hover size="sm" responsive>
      <thead>
        <tr>
          <th>Nível</th>
          <th>Usuário</th>
          <th>Status</th>
          <th>Suplente</th>
          <th>Vigente Até</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {linhas.map((item) => {
          const key = item._fixed ? 'gestor' : (item.codigo_usuario + '_' + item.tipo);
          const isAtivo = item.status === 'A';
          const apelidoSuplente = item.suplente_nome ? item.suplente_nome : '—';
          const dataAte =
            item.suplente_ate
              ? moment(item.suplente_ate).format('DD/MM/YYYY')
              : '—';

          return (
            <tr key={key} className={item._fixed ? 'table-secondary' : ''}>
              <td>{item.nivel}</td>
              <td>{item.nome}</td>
              <td>
                <Badge variant={isAtivo ? 'success' : 'secondary'}>
                  {isAtivo ? 'Ativo' : 'Inativo'}
                </Badge>
              </td>
              <td>{apelidoSuplente}</td>
              <td>{dataAte}</td>
              <td>
                <Button
                  variant={isAtivo ? 'outline-warning' : 'outline-success'}
                  size="sm"
                  title={isAtivo ? 'Inativar' : 'Ativar'}
                  disabled={item._fixed}
                  onClick={() => !item._fixed && onToggleStatus(item)}
                  className="mr-1"
                >
                  {isAtivo ? <FaPause /> : <FaPlay />}
                </Button>
                <Button
                  variant="outline-info"
                  size="sm"
                  title="Adicionar Suplente"
                  disabled={item._fixed}
                  onClick={() => !item._fixed && onAdicionarSuplente(item)}
                  className="mr-1"
                >
                  <FaUserPlus />
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  title="Excluir"
                  disabled={item._fixed}
                  onClick={() => !item._fixed && onExcluir(item)}
                >
                  <FaTrash />
                </Button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default GridHierarquia;
